import { EntityIdToName, SheetGroup } from '../../../types';
import {
  CreateSheet,
  DeleteSheet,
} from '../../../types/commands/sheetCommands/sheetCommands';
import {
  CreateSheetGroup,
  DeleteSheetGroup,
} from '../../../types/commands/sheetGroupsCommands/sheetGroupCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import { v4 as uuid } from 'uuid';
import { getUniqueEntityName } from '../../entityIdToName/entityIdToName';

export const saveCreationEvent = (
  set: SheetManagementSet,
  action: CreateSheet | CreateSheetGroup,
  reverse?: DeleteSheet | DeleteSheetGroup
) => {
  if (!set.present.creationCommands) set.present.creationCommands = [];
  set.present.creationCommands.push(action);

  if (reverse) {
    if (!set.past.deletionCommands) set.past.deletionCommands = [];
    set.past.deletionCommands.push(reverse);
  }
};

export const saveDeletionEvent = (
  set: SheetManagementSet,
  action: DeleteSheet | DeleteSheetGroup,
  reverse?: CreateSheet | CreateSheetGroup
) => {
  if (!set.present.deletionCommands) set.present.deletionCommands = [];
  set.present.deletionCommands.push(action);

  if (reverse) {
    if (!set.past.creationCommands) set.past.creationCommands = [];
    set.past.creationCommands.push(reverse);
  }
};

export const generateNewGroup = (
  groupsIdToName: EntityIdToName
): SheetGroup => {
  const id = uuid();
  const name = getUniqueEntityName(groupsIdToName, true);

  return {
    id,
    name,
    sheets: [],
  };
};
